import { ComponentMap } from '@cinch-nx/data-storyblok'
import {
  TextInlineImageSectionWrapper,
  SectionWithImageV2Wrapper,
  PreFooterCtaV2Wrapper,
} from '../../components'
import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'
import { RichTextWrapper } from '../../components/rich-text-wrapper/rich-text-wrapper'
import { FeatureCardRowWrapper } from '../../components/feature-card-row-wrapper'

const localStoryblokComponents: ComponentMap = {
  LandingTextInlineImageSection: TextInlineImageSectionWrapper,
  SectionWithImageV2: SectionWithImageV2Wrapper,
  PreFooterCtaV2: PreFooterCtaV2Wrapper,
  RichText: RichTextWrapper,
  FeatureCardRowWrapper: FeatureCardRowWrapper,
}

export const storyblokComponentsDelivery: ComponentMap = {
  ...landingStoryblokComponents,
  ...localStoryblokComponents,
}
